PJQ.constants.reports = {
    dynamicDates: [
        {
            value: "pastYear",
            display: "Past Year"
        },
        {
            value: "pastSixMonths",
            display: "Past 6 Months"
        },
        {
            value: "pastThreeMonths",
            display: "Past 3 Months"
        },
        {
            value: "pastMonth",
            display: "Past 1 Month"
        },
        {
            value: "pastTwoWeeks",
            display: "Past 2 Weeks"
        },
        {
            value: "pastWeek",
            display: "Past Week"
        },
        {
            value: "sinceYesterday",
            display: "Since Yesterday"
        },
        {
            value: "throughTomorrow",
            display: "Through Tomorrow"
        },
        {
            value: "nextWeek",
            display: "Next Week"
        },
        {
            value: "nextTwoWeeks",
            display: "Next 2 Weeks"
        },
        {
            value: "nextMonth",
            display: "Next 1 Month"
        },
        {
            value: "nextThreeMonths",
            display: "Next 3 Months"
        },
        {
            value: "nextSixMonths",
            display: "Next 6 Months"
        },
        {
            value: "nextYear",
            display: "Next 1 Year"
        }
    ],
    supportedCustomFieldTypes: [
        'INT',
        'PERCENT',
        'MONEY',
        'STATE',
        // 'CALC',
        'PHONE',
        'TEXT',
        'TEXTAREA',
        'BOOL',
        'CHOICE',
        // GRID: 'GRID',
        // 'CUSTOMGRID'
        // 'GROUPSELECT',
        // 'REGIONSELECT',
        // 'DOWNLOAD',
        // 'UPLOAD',
        // 'FILE',
        'DATE',
        // 'TIME',
        'DATETIME',
    ],
    reportCategorySort: {
        "Custom Reports": 1,
        "Contacts": 2,
        "Project General": 3,
        "Field Tools": 4,
        "Job Costing": 5
    },
    makeCustomReportType: function (key, name, columns = [], filters = []) {
        return {
            name: name,
            type: key,
            key: key,
            viewItemColumn: '',
            viewRelatedItemColumn: '',
            isCustom: true,
            category: '',
            columns: columns ?? [],
            filters: filters ?? []
        };
    },
    reportTypes: {
        PROJECT_CONTACTS: {
            name: 'Project Contacts',
            type: 'projectContacts',
            key: 'PROJECT_CONTACTS',
            category: 'Contacts',
            isGlobalLevel: false,
            columns: [
                {
                    value: "project",
                    display: "Project"
                },
                {
                    value: "userType",
                    display: "User Type"
                },
                {
                    value: "companyName",
                    display: "Company Name"
                },
                {
                    value: "contactName",
                    display: "Contact Name"
                },
                {
                    value: "email",
                    display: "Email"
                },
                {
                    value: "phone",
                    display: "Phone"
                },
                {
                    value: "cell",
                    display: "Cell"
                },
                {
                    value: "trades",
                    display: "Trades"
                }
            ],
            filters: [
                {
                    name: 'User Types',
                    key: 'userTypes',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: async function (options) {
                        return new Promise(async (res, rej) => {
                            PJQ.app.session.fetchUserTypes((userTypes) => {
                                res(_.map(userTypes.models, (userType) => {
                                    return {
                                        id: userType.id,
                                        name: userType.get('name')
                                    };
                                }));
                            });
                        });
                    },
                }
            ]
        },
        PREQUAL: {
            name: 'Prequalifications',
            type: 'prequal',
            key: 'PREQUAL',
            category: 'Contacts',
            isProjectLevel: false,
            filterProjects: false,
            columns: async function () {
                let result = [],
                    formData = await PJQ.app.session.fetchPrequalForm();
                if (formData == null || _.size(formData.tabs) === 0) {
                    return result;
                }

                result.push({
                    value: "percentComplete",
                    display: "Overall Progress",
                    group: "Progress"
                });

                let fnMakeCol = (value, name, group, isControlled = false) => {
                    let fieldName = PJQ.templating.TemplateRenderer.parseMarkup(name, {
                        currentYear: PJQ.helpers.dateHelpers.getCurrentYear()
                    });
                    return {
                        value: value,
                        display: '<div class="of-hidden tof-ellipsis no-wrap max-wd-400p pr-4" title="' + fieldName + '">' + (isControlled ? '> ' : '') + fieldName + '</div>',
                        group: group
                    };
                };
                result.push(..._.map(formData.tabs, (tab) => {
                    return fnMakeCol("tabProgress_" + tab.prequalTabId, tab.tabName + " Progress", "Progress");
                }));

                result.push(..._.map(PJQ.constants.reports.reportTypes.PREQUAL.baseColumns.dates, (col) => {
                    return {
                        value: col.value,
                        display: col.display,
                        group: "Dates"
                    };
                }));

                let fieldCols = [],
                    hasContactFields = false;
                _.each(formData.tabs, (tab) => {
                    fieldCols.push(..._.map(_.filter(tab.fields, (field) => {
                        return _.size(field.fieldType) > 0 && PJQ.constants.reports.supportedCustomFieldTypes.indexOf(field.fieldType.toUpperCase()) !== -1;
                    }), (field) => {
                        hasContactFields = hasContactFields || field.fieldName && field.fieldName.toLowerCase().indexOf('contact.') !== -1;

                        let isControlled = null != _.findWhere(field.constraints, {customFieldId: field.prequalFieldId});
                        return fnMakeCol("cf_" + field.prequalFieldId, field.fieldName, tab.tabName, isControlled);
                    }));
                });

                if (!hasContactFields) {
                    let cGroup = 'Contact Info';
                    result.push({
                            value: "contact.companyName",
                            display: "Company Name",
                            group: cGroup
                        },
                        {
                            value: "contact.address",
                            display: "Address",
                            group: cGroup
                        },
                        {
                            value: "contact.city",
                            display: "City",
                            group: cGroup
                        },
                        {
                            value: "contact.state",
                            display: "State",
                            group: cGroup
                        }, {
                            value: "contact.zip",
                            display: "Zip",
                            group: cGroup
                        }, {
                            value: "contact.country",
                            display: "Country",
                            group: cGroup
                        });
                }

                result.push(...fieldCols);

                return result;
            },
            baseColumns: {
                dates: [
                    {
                        value: "signedOn",
                        display: "Date Signed"
                    },
                    {
                        value: "expiresOn",
                        display: "Expiration"
                    },
                    {
                        value: "modifiedOn",
                        display: "Last Modified"
                    },
                    {
                        value: "lastRequestedOn",
                        display: "Last Requested"
                    },
                ]
            },
            filters: [
                {
                    name: 'Date Signed',
                    inputType: 'daterange',
                    dynamicKey: 'signedOn',
                    key: 'signedOn',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                },
                {
                    name: 'Expiration',
                    inputType: 'daterange',
                    dynamicKey: 'expiresOn',
                    key: 'expiresOn',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                },
                {
                    name: 'Last Modified',
                    inputType: 'daterange',
                    dynamicKey: 'modifiedOn',
                    key: 'modifiedOn',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        CONTRACT: {
            name: 'Contracts',
            type: 'contract',
            key: 'CONTRACT',
            category: 'Job Costing',
            viewItemColumn: 'number',
            columns: [
                {value: "project", display: "Project"},
                {value: "status", display: "Status"},
                {value: "number", display: "Number"},
                {value: "description", display: "Description"},
                {value: "created", display: "Created"},
                {value: "start", display: "Start"},
                {value: "estimatedComplete", display: "Est. Complete"},
                {value: "substantialComplete", display: "Substantial Complete"},
                {value: "actualComplete", display: "Act. Complete"},
                {value: "contractDate", display: "Contract Date"},
                {value: "signedDate", display: "Signed Date"},
                {value: "executionDate", display: "Execution Date"},
                {value: "issuedOn", display: "Issued On"},
                {value: "returnedOn", display: "Returned On"},
                {value: "letterOfIntent", display: "Letter Of Intent"},
                {value: "approvalLetter", display: "Approval Letter"},
                {value: "terminationDate", display: "Termination Date"},
                {value: "inclusions", display: "Inclusions"},
                {value: "exclusions", display: "Exclusions"},
                {value: "executed", display: "Executed"},
                {value: "amount", display: "Amount"},
                {value: "approvedChanges", display: "Approved Changes"},
                {value: "contractTotal", display: "Contract Total"},
                {value: "billedToDate", display: "Billed To Date"},
                {value: "amountRemaining", display: "Amount Remaining"},
            ],
            filters: [
                {
                    name: 'Contract Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.primeContracts.primeContractStatus, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.primeContracts.primeContractStatusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Created On Date',
                    inputType: 'daterange',
                    dynamicKey: 'createdOn',
                    key: 'createdOn',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        CONTRACT_CHANGE_ORDER: {
            name: 'Contract Change Orders',
            type: 'contractChangeOrder',
            key: 'CONTRACT_CHANGE_ORDER',
            viewItemColumn: 'number',
            viewRelatedItemColumn: 'contract',
            category: 'Job Costing',
            columns: [
                {value: "project", display: "Project"},
                {value: "status", display: "Status"},
                {value: "contract", display: "Contract"},
                {value: "number", display: "Number"},
                {value: "description", display: "Description"},
                {value: "invoicedDate", display: "Invoiced Date"},
                {value: "dueDate", display: "Due Date"},
                {value: "created", display: "Created"},
                {value: "amount", display: "Amount"},
            ],
            filters: [
                {
                    name: 'Change Order Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.primeContracts.changeOrderStatus, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.primeContracts.changeOrderStatusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Due Date',
                    inputType: 'daterange',
                    dynamicKey: 'dueDate',
                    key: 'dueDate',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        CHANGE_REQUEST: {
            name: 'Change Requests',
            type: 'changeRequest',
            key: 'CHANGE_REQUEST',
            viewItemColumn: 'number',
            viewRelatedItemColumn: 'contract',
            category: 'Job Costing',
            columns: [
                {value: "project", display: "Project"},
                {value: "number", display: "Number"},
                {value: "contract", display: "Contract"},
                {value: "title", display: "Title"},
                {value: "scope", display: "Scope"},
                {value: "client", display: "Client"},
                {value: "status", display: "Status"},
                {value: "description", display: "Description"},
                {value: "cost", display: "Cost"},
                {value: "revenue", display: "Revenue"},
                {value: "markupAmount", display: "Markup"},
                {value: "taxAmount", display: "Tax"},
                {value: "grandTotal", display: "Grand Total"},
                {value: "created", display: "Created"},
            ],
            filters: [
                {
                    name: 'Created On Date',
                    inputType: 'daterange',
                    dynamicKey: 'createdOn',
                    key: 'createdOn',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                },
                {
                    name: 'Change Request Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.changeRequests.changeRequestStatus, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.changeRequests.changeRequestStatusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Scope',
                    key: 'scope',
                    isIntChoices: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.changeRequests.scope, (id) => {
                        return {
                            id: id,
                            name: PJQ.constants.changeRequests.scopeNames[id]
                        };
                    })
                }
            ]
        },
        COMMITMENT: {
            name: 'Commitments',
            type: 'commitment',
            key: 'COMMITMENT',
            viewItemColumn: 'number',
            category: 'Job Costing',
            columns: [
                {value: "project", display: "Project"},
                {value: "created", display: "Created"},
                {value: "type", display: "Type"},
                {value: "number", display: "Number"},
                {value: "description", display: "Description"},
                {value: "delivery", display: "Delivery"},
                {value: "start", display: "Start"},
                {value: "estimatedComplete", display: "Est. Complete"},
                {value: "actualComplete", display: "Act. Complete"},
                {value: "contractDate", display: "Contract Date"},
                {value: "signedDate", display: "Signed Date"},
                {value: "executionDate", display: "Execution Date"},
                {value: "issuedOn", display: "Issued On"},
                {value: "returnedOn", display: "Returned On"},
                {value: "letterOfIntent", display: "Letter Of Intent"},
                {value: "approvalLetter", display: "Approval Letter"},
                {value: "paymentTerms", display: "Payment Terms"},
                {value: "shippingInfo", display: "Shipping Info"},
                {value: "inclusions", display: "Inclusions"},
                {value: "exclusions", display: "Exclusions"},
                {value: "company", display: "Company"},
                {value: "status", display: "Status"},
                {value: "amount", display: "Amount"},
                {value: "approvedChanges", display: "Approved Changes"},
                {value: "contractTotal", display: "Contract Total"},
                {value: "billedToDate", display: "Billed To Date"},
                {value: "amountRemaining", display: "Amount Remaining"},
            ],
            filters: [
                {
                    name: 'Commitment Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.commitments.commitmentStatus, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.commitments.commitmentStatusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Created On Date',
                    inputType: 'daterange',
                    dynamicKey: 'createdOn',
                    key: 'createdOn',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        COMMITMENT_CHANGE_ORDER: {
            name: 'Commitment Change Orders',
            type: 'commitmentChangeOrder',
            key: 'COMMITMENT_CHANGE_ORDER',
            viewItemColumn: 'number',
            viewRelatedItemColumn: 'commitment',
            category: 'Job Costing',
            columns: [
                {value: "project", display: "Project"},
                {value: "status", display: "Status"},
                {value: "commitment", display: "Commitment"},
                {value: "company", display: "Company"},
                {value: "number", display: "Number"},
                {value: "description", display: "Description"},
                {value: "contractDate", display: "Contract Date"},
                {value: "invoicedDate", display: "Invoiced Date"},
                {value: "dueDate", display: "DueDate"},
                {value: "created", display: "Created"},
                {value: "amount", display: "Amount"},
            ],
            filters: [
                {
                    name: 'Change Order Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.commitments.changeOrderStatus, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.commitments.changeOrderStatusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Due Date',
                    inputType: 'daterange',
                    dynamicKey: 'dueDate',
                    key: 'dueDate',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        CUSTOM: {
            name: 'Custom',
            type: 'custom',
            key: 'CUSTOM',
            viewItemColumn: '',
            viewRelatedItemColumn: '',
            isCustom: true,
            category: '',
            columns: [],
            filters: []
        },
        DIRECT_COST: {
            name: 'Direct Costs',
            type: 'directCost',
            key: 'DIRECT_COST',
            viewItemColumn: 'created',
            category: 'Job Costing',
            columns: [
                {value: "project", display: "Project"},
                {value: "created", display: "Created"},
                {value: "type", display: "Type"},
                {value: "status", display: "Status"},
                {value: "description", display: "Description"},
                {value: "company", display: "Company"},
                {value: "contact", display: "Contact"},
                {value: "terms", display: "Terms"},
                {value: "applied", display: "Applied"},
                {value: "received", display: "Received"},
                {value: "paid", display: "Paid"},
                {value: "amount", display: "Amount"},
            ],
            filters: [
                {
                    name: 'Direct Cost Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.directcosts.directCostStatus, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.directcosts.directCostStatusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Created On Date',
                    inputType: 'daterange',
                    dynamicKey: 'createdOn',
                    key: 'createdOn',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        // PRODUCTION_QUANTITIES: {
        //     name: 'Production Quantities',
        //     type: 'productionQuantities',
        //     key: 'PRODUCTION_QUANTITIES',
        //     // viewItemColumn: 'created',
        //     category: 'Field Tools',
        //     columns: [
        //         {value: "project", display: "Project"},
        //         {value: "subJob", display: "Sub Job"},
        //         {value: "costCode", display: "Cost Code"},
        //         {value: "quantity", display: "Quantity"},
        //         {value: "installedQuantity", display: "Installed Quantity"},
        //         {value: "unit", display: "Unit"},
        //         {value: "description", display: "Description"}
        //     ],
        //     filters: [
        //         {
        //             name: 'Created On Date',
        //             inputType: 'daterange',
        //             dynamicKey: 'createdOn',
        //             key: 'createdOn',
        //             dates: [
        //                 {
        //                     name: 'From',
        //                     key: 'fromDate'
        //                 },
        //                 {
        //                     name: 'To',
        //                     key: 'toDate'
        //                 }
        //             ]
        //         }
        //     ]
        // },
        PAYABLE_INVOICE: {
            name: 'Payable Invoices',
            type: 'payableInvoice',
            key: 'PAYABLE_INVOICE',
            viewItemColumn: 'number',
            viewRelatedItemColumn: 'commitment',
            category: 'Job Costing',
            columns: [
                {
                    value: "project",
                    display: "Project"
                },
                {
                    value: "number",
                    display: "Number"
                },
                {
                    value: "commitment",
                    display: "Commitment"
                },
                {
                    value: "company",
                    display: "Company"
                },
                {
                    value: "billingDate",
                    display: "Due Date"
                },
                {
                    value: "startDate",
                    display: "Start Date"
                },
                {
                    value: "endDate",
                    display: "End Date"
                },
                {
                    value: "status",
                    display: "Status"
                },
                {
                    value: "amount",
                    display: "Amount"
                },
                {
                    value: "notes",
                    display: "Notes"
                },
            ],
            filters: [
                {
                    name: 'Invoice Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.invoicing.payableInvoiceStatus, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.invoicing.payableInvoiceStatusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Due Date',
                    inputType: 'daterange',
                    dynamicKey: 'billingDate',
                    key: 'billingDate',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                },
            ]
        },
        PAYABLE_INVOICE_PAYMENT: {
            name: 'Payable Invoice Payments',
            type: 'payableInvoicePayment',
            key: 'PAYABLE_INVOICE_PAYMENT',
            viewItemColumn: 'number',
            viewRelatedItemColumn: 'invoice',
            category: 'Job Costing',
            columns: [
                {
                    value: "project",
                    display: "Project"
                },
                {
                    value: "number",
                    display: "Number"
                },
                {
                    value: "invoice",
                    display: "Invoice"
                },
                {
                    value: "company",
                    display: "Company"
                },
                {
                    value: "dateReceived",
                    display: "Date Received"
                },
                {
                    value: "paymentMethod",
                    display: "Payment Method"
                },
                {
                    value: "notes",
                    display: "Notes"
                },
                {
                    value: "amount",
                    display: "Amount"
                }
            ],
            filters: [
                {
                    name: 'Date Received',
                    inputType: 'daterange',
                    dynamicKey: 'dateReceived',
                    key: 'dateReceived',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                },
            ]
        },
        RECEIVABLE_INVOICE: {
            name: 'Receivable Invoices',
            type: 'receivableInvoice',
            key: 'RECEIVABLE_INVOICE',
            viewItemColumn: 'number',
            viewRelatedItemColumn: 'contract',
            category: 'Job Costing',
            columns: [
                {
                    value: "project",
                    display: "Project"
                },
                {
                    value: "number",
                    display: "Number"
                },
                {
                    value: "contract",
                    display: "Contract"
                },
                {
                    value: "billingDate",
                    display: "Billing Date"
                },
                {
                    value: "startDate",
                    display: "Start Date"
                },
                {
                    value: "endDate",
                    display: "End Date"
                },
                {
                    value: "status",
                    display: "Status"
                },
                {
                    value: "amount",
                    display: "Amount"
                },
                {
                    value: "notes",
                    display: "Notes"
                }
            ],
            filters: [
                {
                    name: 'Invoice Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.invoicing.receivableInvoiceStatus, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.invoicing.receivableInvoiceStatusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Billing Date',
                    inputType: 'daterange',
                    dynamicKey: 'billingDate',
                    key: 'billingDate',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        RECEIVABLE_INVOICE_PAYMENT: {
            name: 'Receivable Invoice Payments',
            type: 'receivableInvoicePayment',
            key: 'RECEIVABLE_INVOICE_PAYMENT',
            viewItemColumn: 'number',
            viewRelatedItemColumn: 'invoice',
            category: 'Job Costing',
            columns: [
                {
                    value: "project",
                    display: "Project"
                },
                {
                    value: "number",
                    display: "Number"
                },
                {
                    value: "invoice",
                    display: "Invoice"
                },
                {
                    value: "client",
                    display: "Client"
                },
                {
                    value: "dateReceived",
                    display: "Date Received"
                },
                {
                    value: "paymentMethod",
                    display: "Payment Method"
                },
                {
                    value: "notes",
                    display: "Notes"
                },
                {
                    value: "amount",
                    display: "Amount"
                }
            ],
            filters: [
                {
                    name: 'Date Received',
                    inputType: 'daterange',
                    dynamicKey: 'dateReceived',
                    key: 'dateReceived',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                },
            ]
        },
        ACTION_ITEM: {
            name: 'Action Items',
            type: 'actionItem',
            key: 'ACTION_ITEM',
            category: 'Field Tools',
            columns: [
                {
                    value: "project",
                    display: "Project"
                },
                {
                    value: "title",
                    display: "Title"
                },
                {
                    value: "itemNumber",
                    display: "Number"
                },
                {
                    value: "dueDate",
                    display: "Due"
                },
                {
                    value: "priority",
                    display: "Priority"
                },
                {
                    value: "category",
                    display: "Category"
                },
                {
                    value: "location",
                    display: "Location"
                },
                {
                    value: "groupList",
                    display: "Trades"
                },
                {
                    value: "status",
                    display: "Status"
                },
                {
                    value: "assignedTo",
                    display: "Assigned To"
                },
                {
                    value: "ballInCourt",
                    display: "Ball In Court"
                }
            ],
            customFields: function () {
                return PJQ.app.session.fetchActionItemCustomFields();
            },
            filters: [
                {
                    name: 'Item Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.actionItems.statuses, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.actionItems.statusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Due Date',
                    inputType: 'daterange',
                    dynamicKey: 'dueDate',
                    key: 'dueDate',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        PUNCH_LIST: {
            name: 'Punch List',
            type: 'punchList',
            key: 'PUNCH_LIST',
            category: 'Field Tools',
            columns: [
                {
                    value: "project",
                    display: "Project"
                },
                {
                    value: "title",
                    display: "Title"
                },
                {
                    value: "itemNumber",
                    display: "Number"
                },
                {
                    value: "dueDate",
                    display: "Due"
                },
                {
                    value: "assignedTo",
                    display: "Assigned To"
                },
                {
                    value: "priority",
                    display: "Priority"
                },
                {
                    value: "category",
                    display: "Category"
                },
                {
                    value: "location",
                    display: "Location"
                },
                {
                    value: "groupList",
                    display: "Trades"
                },
                {
                    value: "status",
                    display: "Status"
                },
            ],
            customFields: function () {
                return PJQ.app.session.fetchPunchListCustomFields();
            },
            filters: [
                {
                    name: 'Item Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.punchlists.statuses, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.punchlists.statusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Due Date',
                    inputType: 'daterange',
                    dynamicKey: 'dueDate',
                    key: 'dueDate',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        RFI: {
            name: 'RFI',
            type: 'rfi',
            key: 'RFI',
            category: 'Field Tools',
            columns: [
                {
                    value: "project",
                    display: "Project"
                },
                {
                    value: "title",
                    display: "Title"
                },
                {
                    value: "number",
                    display: "Number"
                },
                {
                    value: "dueDate",
                    display: "Due"
                },
                {
                    value: "location",
                    display: "Location"
                },
                {
                    value: "trades",
                    display: "Trades"
                },
                {
                    value: "status",
                    display: "Status"
                },
            ],
            filters: [
                {
                    name: 'Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.rfi.statuses, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.rfi.statusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Due Date',
                    inputType: 'daterange',
                    dynamicKey: 'dueDate',
                    key: 'dueDate',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        SUBMITTAL: {
            name: 'Submittals',
            type: 'submittal',
            key: 'SUBMITTAL',
            category: 'Field Tools',
            columns: [
                {
                    value: "project",
                    display: "Project"
                },
                {
                    value: "submittalNumber",
                    display: "Number"
                },
                {
                    value: "title",
                    display: "Title"
                },
                {
                    value: "itemTypes",
                    display: "Item Types"
                },
                {
                    value: "dueDate",
                    display: "Due Date"
                },
                {
                    value: "groupList",
                    display: "Trades"
                },
                {
                    value: "notes",
                    display: "Description"
                },
                {
                    value: "status",
                    display: "Status"
                },
                {
                    value: "ballInCourt",
                    display: "Ball In Court"
                },
                {
                    value: "submitter",
                    display: "Submitter"
                },
                {
                    value: "approverList",
                    display: "Approver List"
                },
                {
                    value: "distributionList",
                    display: "Distribution List"
                }
            ],
            customFields: function () {
                return PJQ.app.session.fetchSubmittalCustomFields();
            },
            filters: [
                {
                    name: 'Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: async function (options) {
                        return new Promise(async (res, rej) => {
                            let statuses;
                            if (options && options.project != null) {
                                statuses = await options.project.fetchSubmittalStatuses();
                            } else {
                                statuses = await PJQ.app.session.fetchSubmittalStatuses();
                            }
                            if (statuses == null) {
                                rej('Failed to fetch statuses');
                            }

                            res(_.map(statuses.models, (status) => {
                                return {
                                    id: status.id,
                                    name: status.get('name')
                                };
                            }));
                        });
                    },
                },
                {
                    name: 'Due Date',
                    inputType: 'daterange',
                    dynamicKey: 'dueDate',
                    key: 'dueDate',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        MEETING: {
            name: 'Meetings',
            type: 'meeting',
            key: 'MEETING',
            category: 'Field Tools',
            columns: [
                {
                    value: "project",
                    display: "Project"
                },
                {
                    value: "name",
                    display: "Name"
                },
                {
                    value: "number",
                    display: "Number"
                },
                {
                    value: "status",
                    display: "Status"
                },
                {
                    value: "date",
                    display: "Date"
                },
                {
                    value: "startTime",
                    display: "Start Time"
                },
                {
                    value: "endTime",
                    display: "End Time"
                },
                {
                    value: "description",
                    display: "Description"
                },
                {
                    value: 'location',
                    display: "Location"
                },
                {
                    value: "isPublic",
                    display: "Public"
                },
            ],
            filters: [
                {
                    name: 'Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.meetings.meetingStatus, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.meetings.meetingStatusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Meeting Date',
                    inputType: 'daterange',
                    dynamicKey: 'meetingDate',
                    key: 'meetingDate',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        DAILY_REPORT: {
            name: 'Daily Reports',
            type: 'dailyReport',
            key: 'DAILY_REPORT',
            sortName: 'Daily Report',
            category: 'Field Tools',
            columns: [
                {
                    value: "project",
                    display: "Project"
                },
                {
                    value: "reportDate",
                    display: "Report Date"
                },
                {
                    value: "status",
                    display: "Status"
                },
                {
                    value: "workLogs",
                    display: "Work Logs"
                },
                {
                    value: "notes",
                    display: "Notes"
                },
                {
                    value: "surveyItems",
                    display: "Survey Items"
                },
                {
                    value: "expenses",
                    display: "Expenses"
                },
                {
                    value: 'deliveries',
                    display: "Deliveries"
                },
                {
                    value: "communicationLogs",
                    display: "Communication Logs"
                },
                {
                    value: "inspectionLogs",
                    display: "Inspection Logs"
                },
                {
                    value: "wasDelayed",
                    display: "Delayed"
                },
                {
                    value: "delayNotes",
                    display: "Delay Notes"
                }
            ],
            filters: [
                {
                    name: 'Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.dailyReports.statuses, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.dailyReports.statusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Report Date',
                    inputType: 'daterange',
                    dynamicKey: 'reportDate',
                    key: 'reportDate',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                },
                {
                    name: 'Delayed',
                    key: 'delayed',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: [
                        {
                            id: 1,
                            name: 'Yes'
                        },
                        {
                            id: 0,
                            name: 'No'
                        }
                    ]
                }
            ]
        },
        DAILY_REPORT_DELIVERY: {
            name: 'Daily Report Deliveries',
            type: 'dailyReportDelivery',
            key: 'DAILY_REPORT_DELIVERY',
            category: 'Field Tools',
            columns: [
                {
                    value: "project",
                    display: "Project"
                },
                {
                    value: "reportDate",
                    display: "Report Date"
                },
                {
                    value: "time",
                    display: "Time Delivered"
                },
                {
                    value: "deliveryFrom",
                    display: "Delivery From"
                },
                {
                    value: "contents",
                    display: "Contents"
                },
                {
                    value: "trackingNumber",
                    display: "Tracking Number"
                },
                {
                    value: "purchaseOrderNumber",
                    display: "Purchase Order Number"
                },
                {
                    value: 'notes',
                    display: "Notes"
                }
            ],
            filters: [
                {
                    name: 'Daily Report Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.dailyReports.statuses, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.dailyReports.statusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Daily Report Date',
                    inputType: 'daterange',
                    dynamicKey: 'reportDate',
                    key: 'reportDate',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        DAILY_REPORT_WORK_LOG: {
            name: 'Daily Report Work Logs',
            type: 'dailyReportWorkLog',
            key: 'DAILY_REPORT_WORK_LOG',
            category: 'Field Tools',
            columns: [
                {
                    value: "project",
                    display: "Project"
                },
                {
                    value: "reportDate",
                    display: "Report Date"
                },
                {
                    value: "name",
                    display: "Name"
                },
                {
                    value: "quantity",
                    display: "Quantity"
                },
                {
                    value: "hours",
                    display: "Hours"
                },
                {
                    value: "overtimeHours",
                    display: "Overtime Hours"
                },
                {
                    value: 'trades',
                    display: "Trades"
                },
                {
                    value: "description",
                    display: "Description"
                },
            ],
            filters: [
                {
                    name: 'Daily Report Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.dailyReports.statuses, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.dailyReports.statusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Daily Report Date',
                    inputType: 'daterange',
                    dynamicKey: 'reportDate',
                    key: 'reportDate',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        DAILY_REPORT_NOTE: {
            name: 'Daily Report Notes',
            type: 'dailyReportNote',
            key: 'DAILY_REPORT_NOTE',
            category: 'Field Tools',
            columns: [
                {
                    value: "project",
                    display: "Project"
                },
                {
                    value: "reportDate",
                    display: "Report Date"
                },
                {
                    value: "category",
                    display: "Category"
                },
                {
                    value: "noteText",
                    display: "Note"
                },
                {
                    value: "created",
                    display: "Created On"
                }
            ],
            filters: [
                {
                    name: 'Daily Report Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.dailyReports.statuses, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.dailyReports.statusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Daily Report Date',
                    inputType: 'daterange',
                    dynamicKey: 'reportDate',
                    key: 'reportDate',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
    },
    filterTypes: {
        DATE: 'date',
        DATE_RANGE: 'daterange',
        SELECT: 'select',
    }
};

PJQ.constants.date = {
    WEEKDAYNAMES: [
        {
            short: "Sun",
            shortest: "Su",
            long: "Sunday",
            bit: 1
        },
        {
            short: "Mon",
            shortest: "M",
            long: "Monday",
            bit: 2
        },
        {
            short: "Tue",
            shortest: "T",
            long: "Tuesday",
            bit: 4
        },
        {
            short: "Wed",
            shortest: "W",
            long: "Wednesday",
            bit: 8
        },
        {
            short: "Thu",
            shortest: "Th",
            long: "Thursday",
            bit: 16
        },
        {
            short: "Fri",
            shortest: "F",
            long: "Friday",
            bit: 32
        },
        {
            short: "Sat",
            shortest: "S",
            long: "Saturday",
            bit: 64
        }
    ]
};